// import { FaInstagramSquare } from 'react-icons/fa'
// import { AiFillLinkedin } from 'react-icons/ai'
import { FaFacebookF } from 'react-icons/fa'
import { FaWhatsapp } from 'react-icons/fa'

export const links = [
  { id: 1, link: '#', title: 'Home' },
  { id: 2, link: '#about', title: 'About' },
  { id: 3, link: '#services', title: 'Services' },
  { id: 4, link: '#portfolio', title: 'Portfolio' },
  { id: 5, link: '#contact', title: 'Contact' },
]

export const socials = [
  {
    id: 1,
    link:
      'client_facebook.com',
    icon: <FaFacebookF />,
  },
  // { id: 2, link: 'https://linkedIn.com', icon: <AiFillLinkedin /> },
  // { id: 3, link: 'https://instagram.com', icon: <FaInstagramSquare /> },
]

export const dantribes = [
  { id: 1, icon: <FaWhatsapp />, link: 'https://wa.me/+18734552140' },
]
